/* ==========================================================================
   hc-categories — Carousel Controller
   Custom Element + Embla Carousel
   ========================================================================== */

if (!customElements.get('hc-categories-carousel')) {
  class HcCategoriesCarousel extends HTMLElement {
    constructor() {
      super();
      this.embla = null;
      this.dotNodes = [];
    }

    connectedCallback() {
      const viewport = this.querySelector('[data-js="viewport"]');
      const indicator = this.querySelector('[data-js="indicator"]');

      if (!viewport || typeof EmblaCarousel === 'undefined') return;

      this.embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        loop: false
      });

      if (indicator) {
        this.buildDots(indicator);
        this.embla.on('select', () => this.updateDots());
        this.embla.on('reinit', () => {
          this.buildDots(indicator);
          this.updateDots();
        });
      }
    }

    disconnectedCallback() {
      if (this.embla) {
        this.embla.destroy();
        this.embla = null;
      }
    }

    /** Build dot indicators from Embla snap list */
    buildDots(container) {
      const snaps = this.embla.scrollSnapList();
      container.innerHTML = '';
      this.dotNodes = [];

      snaps.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'hc-categories__indicator-dot';
        dot.setAttribute('aria-label', 'Go to group ' + (i + 1));
        dot.addEventListener('click', () => this.embla.scrollTo(i));
        container.appendChild(dot);
        this.dotNodes.push(dot);
      });

      this.updateDots();
    }

    /** Toggle active dot */
    updateDots() {
      if (!this.embla || !this.dotNodes.length) return;
      const selected = this.embla.selectedScrollSnap();
      this.dotNodes.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === selected);
      });
    }
  }

  customElements.define('hc-categories-carousel', HcCategoriesCarousel);
}
